type PdfEsignDocument = {
  url?: string | null;
  fileType?: string | null;
};

/** SuperDoc only opens DOCX. Template-builder PDFs, including .pdf URLs typed as DOCX, use the canvas viewer. */
export function isPdfEsignDocument(
  data: PdfEsignDocument | undefined
): boolean {
  if (!data) {
    return false;
  }
  if (String(data.fileType).toUpperCase() === "PDF") {
    return true;
  }
  try {
    return new URL(data.url ?? "", "https://placeholder.invalid").pathname
      .toLowerCase()
      .endsWith(".pdf");
  } catch {
    return false;
  }
}
